<template>
  <div v-if="blok" v-editable="blok">
    <div
      v-if="blok.heroBannerBlok"
      class="mx-break-out h-[65vh] max-h-[1330px] min-h-[550px]"
    >
      <HeroBanner :blok="blok.heroBannerBlok" />
    </div>
    <AgsLazy
      v-for="(content, index) in blok.content"
      :key="content._uid"
      ssr
      :important="Number(index) <= 1"
      placeholder-ratio="16/9"
      :data-component="content.component"
    >
      <component :is="content.component" :blok="content" />
    </AgsLazy>
  </div>
</template>

<script setup lang="ts">
defineProps({
  blok: {
    type: Object,
    required: true,
  },
})
</script>
